import UnderlinedText from "./underlined_text";
import { Grid, Typography, Checkbox } from "@mui/material";
import { fieldHeader } from "../../../../components/fields/field_header";

const ViewOfferingsAtStore = ({ data }: any) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" color={"white"} bgcolor={"red"} p={0.5}>
          OFFERINGS AT STORE:
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Offerings At Store", false)}</Grid>
        <Grid item xs={12}>
          <Checkbox checked={data.offeringPetroleum} /> Petroleum
        </Grid>
        <Grid item xs={12}>
          <Checkbox checked={data.offeringPreparedFood} /> Prepared Food
        </Grid>
        <Grid item xs={12}>
          <Checkbox checked={data.offeringServiceDeli} /> Service Deli
        </Grid>
        <Grid item xs={12}>
          <Checkbox checked={data.offeringBakery} /> Bakery
        </Grid>
        <Grid item xs={12}>
          {" "}
          <Checkbox checked={data.offeringDeli} /> Deli
        </Grid>
        <Grid item xs={12}>
          {" "}
          <Checkbox checked={data.offeringEVCharging} /> EV Charging
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid item>{fieldHeader("Will you carry IGA products?", false)}</Grid>
        <UnderlinedText text={data.carryIGAProducts} />
      </Grid>
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Other Offerings", false)}</Grid>
        <UnderlinedText text={data.otherOfferings} />
      </Grid>
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Interior Sq. Footage", false)}</Grid>
        <UnderlinedText text={data.interiorSquareFootage} />
      </Grid>
    </>
  );
};

export default ViewOfferingsAtStore;
